export default {
  'mapLeftClick': {
    'placeInfo': 'Informations sur le lieu',
    'placeInsidePolygon': 'Placer à l\'intérieur du polygone',
    'polygonArea': 'Surface du polygone',
    'copyLnglat': 'Copier lng, lat',
    'copyLatlng': 'Copier lat, lng',
    'directionsToClickedPoint': 'Cliquez sur ce bouton d\'itinéraire pour démarrer un itinéraire vers le point cliqué sur la carte',
    'lnglatCopied': 'Longitude et latitude copiées',
    'latlngCopied': 'Latitude et longitude copiées'
  }
}
